import { Navigate, Outlet } from "react-router-dom";

const ClientRoutes = ({ isAgent = false }: { isAgent?: boolean }) => {
  if (!isAgent) {
    return <Outlet />;
  }

  return <Navigate to={process.env.REACT_APP_MANAGEMENT!} replace />;
};

export default ClientRoutes;
